module.exports = __webpack_public_path__ + "static/the-right-stuff-1f97913135ad827f2253e54dcd7b465c.jpg";